import React from 'react'

const Block = () => {
    return (
        <div className=" hidden lg:block absolute left-0 top-1/2 -mt-[2em] w-[8em] overflow-hidden z-10 transform -rotate-180">
            <div className="border-[30px] md:border-[36px] border-[#FF5C00] md:h-[46em] md:w-[46em] rounded-full"></div>
        </div>


    )
}

export default Block